import React, { useEffect, useRef, useState } from "react";
import { useWindowSize } from "react-use";
import "./interviews.scss";
import FsLightbox from "fslightbox-react";
import {
  filterIcon,
  listenBg,
  pinterest,
  radio,
  spotify,
  sun,
} from "../../source";
import CommonBanner from "../../components/commonBanner/CommonBanner";
import InterviewsBoxes from "../../components/InterviewsBoxes/InterviewsBoxes";
import {
  interviewsData,
  interviewCategories,
  interviewTypes,
  interviewSortByTypes,
} from "../../data/interviews";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const Interviews = () => {
  const { width } = useWindowSize();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [vidLink, setVidLink] = useState("");
  const [show, setShow] = useState(false);
  const [showFields, setShowFields] = useState("filter by");
  const sectionRef = useRef(null);
  const [margin, setMargin] = useState("");
  const [padding, setPadding] = useState("");

  // New state for filters
  const [selectedTypes, setSelectedTypes] = useState("");
  const [selectedSortBy, setSelectedSortBy] = useState("");
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [filteredData, setFilteredData] = useState(interviewsData);

  const handleWatchClick = (videoLink) => {
    setIsVideoModalOpen(!isVideoModalOpen);
    setVidLink(videoLink);
  };

  const handlefieldClick = (index) => {
    setShowFields((prevIndex) => (prevIndex === index ? null : index));
  };

  // Handle checkbox changes
  const handleTypeChange = (type) => {
    setSelectedTypes((prev) => {
      if (prev === type) {
        return "";
      }
      return type;
    });
  };

  const handleSortByChange = (sortType) => {
    setSelectedSortBy((prev) => {
      if (prev === sortType) {
        return "";
      }
      return sortType;
    });
  };

  const handleTopicChange = (topic) => {
    setSelectedTopics((prev) => {
      const updated = prev.includes(topic)
        ? prev.filter((t) => t !== topic)
        : [...prev, topic];
      return updated;
    });
  };

  const renderCheckboxes = (
    items,
    selectedItems,
    handleChange,
    isSingleSelect = false
  ) => {
    return items.map((item, index) => (
      <label key={index} className="checkbox_input_container">
        <input
          type="checkbox"
          className="check_box"
          checked={
            isSingleSelect
              ? selectedItems === item
              : selectedItems.includes(item)
          }
          onChange={() => handleChange(item)}
        />
        <span className="checkmark"></span>
        <span className="checkbox_text">{item}</span>
      </label>
    ));
  };

  useEffect(() => {
    let filtered = interviewsData;
    const currentDate = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(currentDate.getMonth() - 1);

    if (selectedTypes) {
      filtered = filtered;
      // .filter((item) => {
      //   const itemType =
      //     item.subType === "video" ? "Video Interviews" : "Audio Interviews";
      //   return selectedTypes === itemType;
      // });
    }

    // // Filter by type (Video/Audio)
    // if (selectedTypes.length > 0) {
    //   filtered = filtered.filter((item) => {
    //     const itemType =
    //       item.subType === "video" ? "Video Interviews" : "Audio Interviews";
    //     return selectedTypes.includes(itemType);
    //   });
    // }

    // Filter by sort options
    if (selectedSortBy) {
      const itemDate = new Date();
      filtered = filtered.filter((item) => {
        const interviewDate = new Date(item.interviewDate);

        if (selectedSortBy === "Upcoming Interviews") {
          return interviewDate > itemDate;
        }

        if (selectedSortBy === "Latest Interviews") {
          return interviewDate >= oneMonthAgo && interviewDate <= itemDate;
        }

        if (selectedSortBy === "Past Interviews") {
          return interviewDate < oneMonthAgo;
        }

        return false;
      });
      //sorting logic
      // if (selectedSortBy === "Upcoming Interviews") {
      //   filtered = filtered.sort((a, b) => {
      //     const dateA = new Date(a.interviewDate);
      //     const dateB = new Date(b.interviewDate);
      //     return dateA - dateB;
      //   });
      // } else {
      //   filtered = filtered.sort((a, b) => {
      //     const dateA = new Date(a.interviewDate);
      //     const dateB = new Date(b.interviewDate);
      //     return dateB - dateA;
      //   });
      // }
    }

    // Filter by topics/categories
    if (selectedTopics.length > 0) {
      filtered = filtered.filter((item) =>
        item.category.some((cat) => selectedTopics.includes(cat))
      );
    }
    window.scroll(0, 0);
    setFilteredData(filtered);
  }, [selectedTypes, selectedSortBy, selectedTopics]);

  const updateStyles = () => {
    if (sectionRef.current) {
      const computedStyle = window.getComputedStyle(sectionRef.current);
      setMargin(computedStyle.margin);
      setPadding(computedStyle.padding);
    }
  };

  useEffect(() => {
    updateStyles();
    window.addEventListener("resize", updateStyles);
    return () => {
      window.removeEventListener("resize", updateStyles);
    };
  }, []);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [filteredData]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Insightful podcasts on Growth & Healing Journey - Pathways & Perspectives"
        metaDesc="Explore in-depth interviews with voices shaping the future of holistic wellness, coaching, and conscious living. Real talk. Real transformation."
      />

      <section className="interview_sec1">
        <CommonBanner title="Interviews" linkText1="Interviews" />
      </section>

      <section className="interview_sec2">
        <img src={sun} alt="sun" className="sun_img" />
        <div className="my_container" ref={sectionRef}>
          <div className="row interview_row">
            <div
              className="col-lg-8 interview_col order-lg-2"
              data-aos="fade-up"
            >
              <div className="content_wrapper">
                <InterviewsBoxes
                  boxesData={filteredData}
                  video={handleWatchClick}
                />
                {/* {isLoadingMore && (
                  <div
                    className="loading-text"
                    style={{ textAlign: "center", marginTop: "20px" }}
                  >
                    Loading more interviews...
                  </div>
                )} */}
              </div>
            </div>

            <div
              className="col-lg-4 interview_col order-lg-1"
              data-aos="fade-up"
            >
              {width >= 992 && (
                <form className="form_wrapper">
                  <div className="field_wrapper">
                    <h2 className="field_title">Filter By</h2>
                    {renderCheckboxes(
                      interviewTypes,
                      selectedTypes,
                      handleTypeChange,
                      true
                    )}
                  </div>

                  <div className="field_wrapper">
                    <h2 className="field_title">Sort By</h2>
                    {renderCheckboxes(
                      interviewSortByTypes,
                      selectedSortBy,
                      handleSortByChange,
                      true
                    )}
                  </div>

                  <div className="field_wrapper">
                    <h2 className="field_title">Topics</h2>
                    <div className="checkbox_input_wrapper">
                      {renderCheckboxes(
                        interviewCategories,
                        selectedTopics,
                        handleTopicChange
                      )}
                    </div>
                  </div>
                </form>
              )}

              <div className="listen_wrapper">
                <img src={listenBg} alt="backround" className="bg_img" />
                <h6 className="listen_heading">Also Listen On</h6>
                <div className="listen_icon_wrapper">
                  <a
                    // href="https://open.spotify.com/episode/1NNI3NGvP7VLK6chZCWplN?si=9sR31GQfRwG3pV3nuN8hNA"
                    href="https://open.spotify.com/show/4XAgnIhkFiNoymR2mPvyja?si=fec54f0b57ec4e35"
                    target="_blank"
                    rel="noreferrer"
                    className="listen_link"
                  >
                    <img src={spotify} alt="spotify" className="listen_icon" />
                  </a>
                  <a
                    // href="https://podcasts.apple.com/qa/podcast/pathways-perspectives/id1827234225"
                    href="https://podcasts.apple.com/qa/podcast/pathways-and-perspectives-podcasts/id1827234225"
                    target="_blank"
                    rel="noreferrer"
                    className="listen_link"
                  >
                    <img
                      src={pinterest}
                      alt="pinterest"
                      className="listen_icon"
                    />
                  </a>{" "}
                  {/*
                  <a
                    href="https://open.spotify.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="listen_link"
                  >
                    <img src={radio} alt="radio" className="listen_icon" />
                  </a> 
                  */}
                </div>
              </div>
            </div>
          </div>

          {width <= 991 && (
            <div className="filter_container" style={{ margin, padding }}>
              <div className={`interview_row ${show ? "active" : ""}`}>
                <div className="interview_col">
                  <div className="form_wrapper">
                    <div className="field_wrapper">
                      <h2
                        className="field_title"
                        onClick={() => handlefieldClick("filter by")}
                      >
                        Filter By
                      </h2>
                      <div
                        className={`fields_details ${
                          showFields === "filter by" ? "active" : ""
                        }`}
                      >
                        {renderCheckboxes(
                          interviewTypes,
                          selectedTypes,
                          handleTypeChange,
                          true
                        )}
                      </div>
                    </div>

                    <div className="field_wrapper">
                      <h2
                        className="field_title"
                        onClick={() => handlefieldClick("sort by")}
                      >
                        Sort By
                      </h2>
                      <div
                        className={`fields_details ${
                          showFields === "sort by" ? "active" : ""
                        }`}
                      >
                        {renderCheckboxes(
                          interviewSortByTypes,
                          selectedSortBy,
                          handleSortByChange,
                          true
                        )}
                      </div>
                    </div>

                    <div className="field_wrapper">
                      <h2
                        className="field_title"
                        onClick={() => handlefieldClick("topics")}
                      >
                        Topics
                      </h2>
                      <div
                        className={`fields_details ${
                          showFields === "topics" ? "active" : ""
                        }`}
                      >
                        <div className="checkbox_input_wrapper">
                          {renderCheckboxes(
                            interviewCategories,
                            selectedTopics,
                            handleTopicChange
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`filter_btn_wrapper ${show ? "active" : ""}`}
                onClick={() => setShow(!show)}
              >
                <img src={filterIcon} alt="filter" className="filter_icon" />
                <p className="filter_title">Filter & Sort</p>
              </div>
            </div>
          )}
        </div>
      </section>

      <section className="interview_lightbox_wrapper">
        <FsLightbox toggler={isVideoModalOpen} sources={[vidLink]} />
      </section>
    </>
  );
};

export default Interviews;
